export const BASIC_ACTIONS = {
  LIBRARY_LOADED: 'plakaObjectLoaded',
  DESTROY: 'plakaDestroy',
  ERROR: 'plakaError'
}

export default BASIC_ACTIONS
